module.exports = __webpack_public_path__ + "img/logo2.4e636ccd.png";